import React, { useEffect } from 'react';
import GridSection from '../../../components/grid-section';
import InfiniteScroll from '../../../components/infinite-scroll';
import Loading from '@ifit/mp-loading';
import { getSearchState } from '../../search/state/search-state';
import { useGetContinueSeries } from '../../../client/query/continue-series';
import useToolbarTitle from '@ifit/hooks/useToolbarTitle';
import { setLastTitle } from '../../../store/to-native';
import { continueSeriesAndChallengesTitle } from '../../../i18n/translations';

export const ContinueSeries: React.FC = () => {
  useToolbarTitle(
    continueSeriesAndChallengesTitle(),
    { buttonStyle: 'back' },
    () => setLastTitle(continueSeriesAndChallengesTitle()),
  );
  useEffect(() => {
    getSearchState().setViewContext({});
  }, []);
  const {
    dataMemo: { data: seriesItems, hasMoreItems },
    query: { isLoading },
    fetchNextPageCallback,
  } = useGetContinueSeries();

  if (isLoading) {
    return <Loading absolute data-testid="loading-spinner" />;
  }

  return (
    <div
      className="continue-series-and-challenges-view"
      data-testid="continue-series-and-challenges-view"
    >
      <InfiniteScroll
        libraryCards={seriesItems}
        hasMoreItems={hasMoreItems}
        loadMore={fetchNextPageCallback}
      >
        <GridSection />
      </InfiniteScroll>
    </div>
  );
};

export default ContinueSeries;
